// extracted by mini-css-extract-plugin
export default {"container":"ShowMoreItems_container__PXX6w","minimize":"ShowMoreItems_minimize__MXGsc"};